import React, { useState } from 'react';

export default function IconBoxStyle1({ title, subTitle, iconUrl }) {

  const [readmore, setReadmore] = useState(false);
  const maxChar = 100;

  return (
    <div className="cs_iconbox cs_style_1 cs_shadow_1 cs_radius_15">
      <div className="cs_iconbox_top">
        <div className="cs_iconbox_icon cs_radius_15 cs_accent_bg cs_center">
          <img src={iconUrl} alt="Icon" />
        </div>
        <h2 className="cs_iconbox_title cs_medium cs_fs_20 m-0">{title}</h2>
      </div>
      <p className="cs_iconbox_text text-justify">
        {readmore ? subTitle : `${subTitle.slice(0, maxChar)}...`}
        {subTitle.length > maxChar && (
          <span
            onClick={() => setReadmore(!readmore)}
            className="cursor-pointer text-[#307bc4] ml-3"
          >
            {readmore ? "Show Less" : "Read More"}
          </span>
        )}
      </p>
    </div>
  );
}
